import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Itemnewsskltn = (props) => {

    const [arry, setArry] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 14, 15, 16, 17, 18, 19, 20])

    return (
        <div className="skltn-row">
            {arry.slice(0, 9).map((info, index) =>
                <a className="item-news skltn" >
                    <div className="pic">
                        <Skeleton animation="wave" variant="rect" width={100 + '%'} height={150} />
                    </div>
                    <h4>
                        <Skeleton animation="wave" variant="text" width={100 + '%'} height={22} />
                    </h4>
                    <p>
                        <Skeleton animation="text" variant="text" width={100 + '%'} height={22} />
                    </p>
                    <div className="row-detailes">
                        <span>
                            <Skeleton animation="wave" variant="text" width={70} height={22} />
                        </span>
                        <div className="view">
                            {props.view == undefined ? null :
                                <span>{props.view}<i className="icon-view"></i></span>
                            }
                            <span>
                                <Skeleton animation="wave" variant="text" width={35} height={22} />
                                <Skeleton animation="wave" variant="text" width={25} height={22} />
                            </span>
                        </div>
                    </div>
                </a>
            )}
        </div>
    );
}

export default Itemnewsskltn;